import {
  useDevCycleClient,
  useVariableValue,
} from "@devcycle/react-client-sdk";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../redux/types";
import { Dispatcher, RootDispatcher } from "../../service/RootDispather";
import { usePrevious } from "../hooks/hooks";

export enum FLAGS {
  EPILEPSY_DETECTION = "epilepsy-detection",
  ENVIRONMENT_TEMPERATURE = "environment-temperature",
  MAINTENANCE_ANNOUNCEMENT = "maintenance-announcement",
  INTEGRATION_PARADIGMA = "integration-paradigma",
  MOBILE_DEVICE_AS_TAG = "mobile-device-as-tag",
}
export const IdentifyUserWithFlags = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const { email, id, firstName, lastName } = useSelector(
    (state: IAppState) => state.userProfile
  );
  const { isBaseUrlRetrieved } = useSelector((state: IAppState) => state.auth);
  const organizationID = useSelector(
    (state: IAppState) => state.organization.organizationId
  );
  const organizationTitle = useSelector(
    (state: IAppState) => state.organization.rootOrganization.title
  );
  const client = useDevCycleClient();
  useEffect(() => {
    if (
      isBaseUrlRetrieved === true &&
      email !== undefined &&
      email !== "" &&
      id !== undefined &&
      id !== null &&
      organizationID !== undefined &&
      organizationID !== null
    ) {
      client.identifyUser({
        user_id: id,
        email: email,
        isAnonymous: false,
        customData: {
          Organization_ID: organizationID,
          Organization_Title: organizationTitle,
        },
      });
    }
  }, [
    email,
    id,
    organizationID,
    client,
    organizationTitle,
    firstName,
    lastName,
    isBaseUrlRetrieved,
  ]);
  const rootDispatcher = Dispatcher();
  return (
    <>
      {Object.values(FLAGS).map((flag) => (
        <OneFlagListener
          flag={flag as FLAGS}
          key={flag}
          rootDispatcher={rootDispatcher}
        />
      ))}
      <>{children}</>
    </>
  );
};
const OneFlagListener = ({
  flag,
  rootDispatcher,
}: {
  flag: FLAGS;
  rootDispatcher: RootDispatcher;
}): JSX.Element => {
  const featureVariable = useVariableValue(flag, false);
  const featurePrev = usePrevious(featureVariable);
  useEffect(() => {
    if (featureVariable !== featurePrev && featurePrev !== undefined) {
      rootDispatcher.changeFeatureFlags({ [flag]: featureVariable });
      // console.log('root state updated');
    } //else console.log('root state not updated', featurePrev, featureVariable);
  }, [featureVariable, featurePrev, rootDispatcher, flag]);
  return null;
};
